/* Warmtable product modules: sticky add-to-cart, gallery, bundle buybox (real /cart/add.js). Requires wt.js.
   Sticky is registered first so it is listening before the buybox announces its first selection.
   Totals match Shopify checkout: discount = floor(subtotal x pct / 100), total = subtotal - discount. */
(() => {
  'use strict';
  const WT = window.WT; if (!WT || !WT.register) return;
  const { $, $$, esc, str } = WT;

  WT.register('[data-wt-sticky]', (bar) => {
    const btn = $('[data-wt-sticky-add]', bar), nm = $('[data-wt-sticky-name]', bar), tot = $('[data-wt-sticky-total]', bar);
    document.addEventListener('wt:selection', (e) => { if (nm) nm.textContent = e.detail.name; if (tot) tot.textContent = e.detail.money; if (btn) btn.disabled = e.detail.disabled; });
    if (btn) btn.addEventListener('click', () => { const bb = $('[data-wt-buybox]'); if (bb && bb.wtAdd) bb.wtAdd(); else if (bb) bb.scrollIntoView(); });
    bar.inert = true;
    if (!('IntersectionObserver' in window)) return;
    const heroCta = $('[data-wt-hero-cta]'), atc = $('[data-wt-add]');
    const st = { past: !heroCta, atc: false };
    const upd = () => { const on = st.past && !st.atc; bar.classList.toggle('is-on', on); bar.inert = !on; };
    if (heroCta) new IntersectionObserver((es) => { st.past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; upd(); }).observe(heroCta);
    if (atc) new IntersectionObserver((es) => { st.atc = es[0].isIntersecting; upd(); }).observe(atc);
  });

  WT.register('[data-wt-gallery]', (g) => {
    const track = $('[data-wt-track]', g); if (!track) return;
    const slides = $$('[data-wt-slide]', g), thumbs = $$('[data-wt-thumb]', g), count = $('[data-wt-count]', g);
    const cur = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = (k) => { k = (k + slides.length) % slides.length; track.scrollTo({ left: k * track.clientWidth, behavior: WT.reduced ? 'auto' : 'smooth' }); };
    const mark = () => { const k = cur(); thumbs.forEach((t, j) => t.setAttribute('aria-current', j === k ? 'true' : 'false')); if (count) count.textContent = k + 1 + ' / ' + slides.length; };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach((t, j) => t.addEventListener('click', () => go(j)));
    const p = $('[data-wt-prev]', g), n = $('[data-wt-next]', g);
    if (p) p.addEventListener('click', () => go(cur() - 1));
    if (n) n.addEventListener('click', () => go(cur() + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); }
    });
    g.wtGo = (mediaId) => { const k = slides.findIndex((s) => s.dataset.mediaId == mediaId); if (k > -1) go(k); };
    mark();
  });

  WT.register('[data-wt-buybox]', (bb) => {
    const dataEl = $('[data-wt-product]', bb); if (!dataEl) return;
    const P = JSON.parse(dataEl.textContent);
    const V = {}; P.variants.forEach((v) => (V[v.id] = v));
    const avail = P.variants.filter((v) => v.available);
    const sw = P.swatches || {};
    const tiles = $$('[data-wt-tile]', bb), colors = $('[data-wt-colors]', bb), btn = $('[data-wt-add]', bb);
    if (!btn) return;
    const totalEl = $('[data-wt-add-label]', bb), txt = $('[data-wt-add-text]', bb), err = $('[data-wt-error]', bb), form = $('form', bb);
    const qtyIn = $('input[name="quantity"]', bb), idIn = $('input[name="id"]', bb), gal = $('[data-wt-gallery]', bb);
    let i = Math.max(0, tiles.findIndex((t) => t.getAttribute('aria-pressed') === 'true'));
    const start = idIn && V[+idIn.value] && V[+idIn.value].available ? +idIn.value : null;
    const def = start || (avail[0] || P.variants[0] || {}).id;
    const picks = [];
    const n = () => (tiles[i] ? +tiles[i].dataset.qty : 1);
    const pct = () => (tiles[i] ? +tiles[i].dataset.pct || 0 : 0);
    const total = () => { const full = picks.reduce((a, id) => a + (V[id] ? V[id].price : 0), 0); return full - Math.floor((full * pct()) / 100); };
    const swc = (id) => (V[id] && sw[V[id].title]) || '';
    function drawColors() {
      while (picks.length < n()) picks.push(def);
      picks.length = n();
      if (!colors || P.variants.length < 2) return;
      colors.innerHTML = picks.map((id, k) => {
        const fid = bb.dataset.section + '-c' + k;
        return '<label for="' + fid + '"><span class="wt-colors__l"><i class="wt-dot" style="background:' + esc(swc(id)) + '"></i>' + esc(P.matLabel) + ' #' + (k + 1) + '</span>' +
          '<select id="' + fid + '" data-k="' + k + '">' + P.variants.map((v) => '<option value="' + v.id + '"' + (v.id === id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' — ' + esc(str('soldOut'))) + '</option>').join('') + '</select></label>';
      }).join('');
    }
    function paint() {
      tiles.forEach((t, k) => {
        t.setAttribute('aria-pressed', k === i ? 'true' : 'false');
        $$('.wt-tile__mats i', t).forEach((m, j) => (m.style.background = k === i ? swc(picks[j]) : ''));
      });
      const t = total();
      if (totalEl) totalEl.textContent = WT.money(t);
      if (qtyIn) qtyIn.value = n();
      if (idIn && picks[0]) idIn.value = picks[0];
      const ok = avail.length > 0 && picks.every((id) => V[id] && V[id].available);
      btn.disabled = !ok;
      if (txt) txt.textContent = ok ? P.addLabel || str('add') : str('soldOut');
      document.dispatchEvent(new CustomEvent('wt:selection', { detail: { name: tiles[i] ? tiles[i].dataset.name : P.title, money: WT.money(t), disabled: !ok } }));
    }
    tiles.forEach((t, k) => t.addEventListener('click', () => { i = k; drawColors(); paint(); }));
    if (colors) colors.addEventListener('change', (e) => {
      const s = e.target.closest('select'); if (!s) return;
      const id = +s.value; picks[+s.dataset.k] = id;
      const dot = s.parentElement.querySelector('.wt-dot'); if (dot) dot.style.background = swc(id);
      paint();
      if (gal && gal.wtGo && V[id] && V[id].media) gal.wtGo(V[id].media);
    });
    async function add() {
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      if (err) err.hidden = true;
      const counts = {}; picks.forEach((id) => (counts[id] = (counts[id] || 0) + 1));
      const items = Object.keys(counts).map((id) => ({ id: +id, quantity: counts[id] }));
      const old = txt ? txt.textContent : '';
      btn.setAttribute('aria-busy', 'true'); if (txt) txt.textContent = str('adding');
      try { await WT.cart.add(items); WT.openCart(await WT.cart.get()); }
      catch (e) { if (err) { err.textContent = e.message || str('error'); err.hidden = false; } }
      finally { btn.removeAttribute('aria-busy'); if (txt) txt.textContent = old; }
    }
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); add(); });
    bb.wtAdd = add;
    drawColors(); paint();
  });
})();